module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/04_shape-sm-e03cdd7b4356d2dd37cce6b984ffae3e.png";